import React from 'react'
import { Card, Button, Modal, Row, Col, Popconfirm, Typography, Tooltip } from 'antd'
import { Icon } from 'xadmin-ui'
import app, { use } from 'xadmin'
import _ from 'lodash'

const errorFormat = error => {
  if (_.isPlainObject(error)) {
    return _.values(error).map(errorFormat).join(' ')
  } else if (_.isArray(error)) {
    return error.map(errorFormat).join(' ')
  } else {
    !_.isNil(error) && console.log(error)
    return error && error.toString()
  }
}

const CardItem = (props) => {
  const { name, title, onRemove, children, item, render: CardRender, index, error, cardItemFunc } = props
  const [show, setShow] = React.useState(item !== undefined && _.isEmpty(item))
  const { form } = use('form')

  const actions = [
    <Icon onClick={() => { setShow(true) }} type="edit" />,
    <Popconfirm
      title="确定删除此项?"
      onConfirm={onRemove}
      onCancel={() => { }}
      okText="确定"
      cancelText="取消"
    >
      <Icon type="delete" />
    </Popconfirm>,
    ...cardItemFunc(props)
  ]
  const onCancel = () => {
    setShow(false)
    _.isEmpty(item !== undefined && item) && onRemove()
  }

  const newChildren = _.isPlainObject(children) && children?.props?.fields?.length ? { ...children,
    props: { 
      ...children.props,
      fields: children.props.fields.filter(item => !item?.schema?.hidden)
    }
  } : children
  const cardTitle = error ? <Tooltip title={errorFormat(error)}><Typography.Text type="danger">{title}</Typography.Text></Tooltip> : title
  return (
    <Col xs={20} sm={16} md={12} lg={8} xl={4} xxl={3} style={{ marginTop: '.5rem' }}>
      {item == undefined ? null : (CardRender ? <CardRender error={errorFormat(error)} title={cardTitle} actions={actions} item={item || {}} index={index} /> : <Card
        title={cardTitle}
        actions={actions}
        index={index}
      >
        <div style={{ overflow: 'hidden', wordBreak: 'keep-all', whiteSpace: 'nowrap', textOverflow: 'ellipsis', padding: '10px' }}>
          {item && item.description || '未填写..'}
        </div>
      </Card>)}
      <Modal
        title={title}
        visible={show}
        width="70%"
        onOk={() => { setShow(false); form.submit() }}
        destroyOnClose
        onCancel={onCancel}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ disabled: error != undefined }}
      >
        {newChildren}
      </Modal>
    </Col>
  )
}

const CardItemsRender = ({ name, input, fields, meta: { error }, search, field, fieldsBuilder, withAdd, page, original, cardItemFunc=()=>([])}) => {
  const vs = _.isArray(input.value) ? input.value : []
  const { items, label, searchFields = ['id', 'name'] } = field
  return (
    <>
      {withAdd !== false && <Button onClick={() => fields.push()}><Icon type="plus" /></Button>}
      {fields.length > 0 ?
        (
          <Row gutter={8} className="ant-table-add-border" style={{ marginTop: '-0.5rem' }}>
            {fields.map((name, index, value) => {
              const item = vs[index]
              let resetIndex = item?.resetIndex || index//original.findIndex(val => (val?.id == item?.id)) || index
              name = `${name.substring(0, name.indexOf('[')+1)}${resetIndex}]`
              if(page?.pageSize && index>page?.pageSize) return 
              return (!search || _.some(searchFields.map(k => item && item[k] && item[k].indexOf(search) >= 0))) ? (
                <CardItem
                  key={`items.${index}`}
                  name={name}
                  title={item && item.name || item && item.warningname || label + ' ' + (index + 1)}
                  onRemove={() => fields.remove(resetIndex)}
                  item={item}
                  render={field.cardRender}
                  index={index}
                  error={error ? error[index] : undefined}
                  cardItemFunc={cardItemFunc}
                >
                  {fieldsBuilder(name, index)}
                </CardItem>
              ) : null
            }).filter(Boolean)}
          </Row>
        ) :
        null
      }
    </>
  )
}

export default CardItemsRender
